module.exports = __webpack_public_path__ + "static/media/logo.33c8b798.svg";